import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BILLABLE_REASON, IChargeItemsInfo, IReference, ISimplifiedChargeItems } from "@comunicare/comunicare-interfaces";
import { first } from "rxjs/operators";
import { BillingService } from "../../services/billing.service";
import { ConfirmationDialogComponent } from "@comunicare/comunicare-dashboard-modals";

@Component({
  selector: "app-invoice-notes-dialog",
  templateUrl: "./invoice-notes-dialog.component.html",
  styleUrls: ["./invoice-notes-dialog.component.scss"],
})
export class InvoiceNotesDialogComponent {
  public isLoading = false;
  public comment: string;
  public notes: { text: string; author?: IReference; time?: string }[] = [];
  public BILLABLE_REASON_KEYS = Object.keys(BILLABLE_REASON);

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { chargeItem: IChargeItemsInfo | ISimplifiedChargeItems },
    private billingService: BillingService
  ) {
    this.notes = this.data.chargeItem?.note?.length ? this.data.chargeItem.note : [];
  }

  public save(): void {
    this.isLoading = true;
    this.billingService
      .addChargeItemComment(
        (this.data.chargeItem as ISimplifiedChargeItems)?.identification ??
          (this.data.chargeItem as IChargeItemsInfo)?.identifier?.[0]?.value,
        this.comment
      )
      .pipe(first())
      .subscribe((newComment) => {
        this.notes.push(newComment);
        this.comment = undefined;
        this.isLoading = false;
      });
  }
}
